"use client";

import { create } from "zustand";
import { getCategories } from "../services/category.service";
import { toCategoryItems } from "../lib/to-category-items";
import type { CategoryItem } from "../types/category-panel";

interface HeaderCategoryPanelState {
    open: boolean;
    /** null = ainda não buscado. Depois do primeiro fetch, fica em cache (sem refetch). */
    categories: CategoryItem[] | null;
    loading: boolean;
    error: boolean;
    openPanel: () => void;
    /** Dispara o fetch das categorias (uma vez) sem abrir o painel fullscreen —
     * usado pelo dropdown de categorias do desktop, que renderiza os dados numa
     * apresentação própria. */
    ensureLoaded: () => void;
    close: () => void;
}

/**
 * Estado do painel de categorias acionado pelo header — UI client-only global
 * (mesmo padrão do useStoreSwitcher). Busca as categorias uma única vez, no
 * primeiro `openPanel()`; aberturas seguintes reusam o cache em memória.
 */
export const useHeaderCategoryPanel = create<HeaderCategoryPanelState>()((set, get) => ({
    open: false,
    categories: null,
    loading: false,
    error: false,
    ensureLoaded: () => {
        if (get().categories !== null || get().loading) return;

        set({ loading: true, error: false });
        getCategories()
            .then((data) => set({ categories: toCategoryItems(data), loading: false }))
            .catch(() => set({ loading: false, error: true }));
    },
    openPanel: () => {
        set({ open: true });
        get().ensureLoaded();
    },
    close: () => set({ open: false }),
}));
